import { isSafari } from "@util/browserUtils";

// Safari-specific token handling
export const safariTokenInterceptor = {
   request: (config) => {
      const token = localStorage.getItem("token");

      if (
         isSafari &&
         token &&
         !config.url.includes("createGuestToken") &&
         !config.url.includes("index.php/restApi/forms-save")
      ) {
         config.headers = {
            ...config.headers,
            Authorization: token,
         };
      }

      return config;
   },
};
